import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { type AppointmentOpenDockFormValues } from '../../infra/ShipmentRepository'
import { updateOpenDockAppointment } from '../../use-cases/updateOpenDockAppointment'

type UpdateAppointmentParams = {
  shipmentUUID: string
  stopIndex: number
  data: AppointmentOpenDockFormValues
}

export function useUpdateOpenDockAppointment() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const update = useCallback(async ({ shipmentUUID, stopIndex, data }: UpdateAppointmentParams) => {
    setRequestStatus(RequestStatus.Pending)
    try {
      await updateOpenDockAppointment({
        shipmentUUID,
        stopIndex,
        data,
      })
      setRequestStatus(RequestStatus.Done)
    } catch (error) {
      setRequestStatus(RequestStatus.Error)
    }
  }, [])

  return { update, requestStatus }
}
